import { Component, Output, EventEmitter, Input } from '@angular/core';
import { UserProvider } from '../../providers/user/user';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ToolsProvider } from '../../providers/tools/tools';
import * as $ from 'jquery';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import {
  Platform,
  NavParams,
  ToastController,
  ModalController,
} from 'ionic-angular';

declare let CmKit: any;

@Component({
  selector: 'job-search-form',
  templateUrl: 'job-search-form.html',
})
export class JobSearchFormComponent {
  log = debug('app:JobSearchFormComponent');

  @Input() registrationInfo = false;
  @Input() submittingApplication = false;
  @Input() showHeader = false;

  // *********** Render Config ********
  saveButtonText = 'Save';
  @Output() formChanged = new EventEmitter();

  // optional info
  isVisible = true;
  currentCompany = {};
  emittedChangesMade = false;
  hasFilledOut = false;
  toastOut = false;
  job;

  // ************ Data Set*************
  hasCDLOptions = [
    { title: 'Yes', type: 'yes', value: false },
    { title: 'No', type: 'no', value: false },
  ];

  experienceOptions = [
    { value: false, type: 'needtraining', title: 'Need CDL Training' },
    { value: false, type: 'intraining', title: 'In CDL School Now' },
    {
      value: false,
      type: 'graduatedtraining',
      title: 'CDL Grad, No Experience',
    },
    { value: false, type: '1-5_months', title: '1-5 Months' },
    { value: false, type: '6-11_months', title: '6-11 Months' },
    { value: false, type: '12-23_months', title: '12-23 Months' },
    { value: false, type: '2_years', title: '2 Years' },
    { value: false, type: '3_years', title: '3 Years' },
    { value: false, type: '4_years', title: '4 Years' },
    { value: false, type: '5+_years', title: '5+ Years' },
  ];

  FreightTypes = [
    { title: 'Dry Van', value: false, type: 'dryVan' },
    { title: 'Flat Bed', value: false, type: 'flatbed' },
    { title: 'Tanker', value: false, type: 'tanker' },
    { title: 'Refrigerated (Reefer)', value: false, type: 'reefer' },
    { title: 'Doubles/Triples', value: false, type: 'doubtrip' },
    { title: 'Intermodal', value: false, type: 'intermodal' },
    { title: 'Auto hauler', value: false, type: 'hauler' },
    { title: 'Household Goods', value: false, type: 'hhg' },
    { title: 'Dry Bulk & Pneumatics', value: false, type: 'dryBulk' },
    { title: 'Specialized/Heavy Haul', value: false, type: 'specialized' },
  ];

  Endorsements = [
    { title: 'H - Hazardous Materials', value: false, type: 'hEndorsement' },
    { title: 'N - Tanker Vehicles', value: false, type: 'nEndorsement' },
    { title: 'T - Doubles or Triples', value: false, type: 'tEndorsement' },
  ];

  Violations = [
    { title: '0', value: false, type: '0' },
    { title: '1', value: false, type: '1' },
    { title: '2', value: false, type: '2' },
    { title: '3', value: false, type: '3' },
    { title: '4', value: false, type: '4' },
    { title: '5+', value: false, type: '5+' },
  ];

  Accidents = [
    { title: '0', value: false, type: '0' },
    { title: '1', value: false, type: '1' },
    { title: '2', value: false, type: '2' },
    { title: '3', value: false, type: '3' },
    { title: '4', value: false, type: '4' },
    { title: '5+', value: false, type: '5+' },
  ];

  TeamDrivers = [
    { title: 'Yes', value: false, type: 'yes' },
    { title: 'No', value: false, type: 'no' },
  ];

  Military = [
    { title: 'Yes', value: false, type: 'yes' },
    { title: 'No', value: false, type: 'no' },
  ];

  ContactTime = [
    { title: 'Anytime', value: false, type: 'anytime' },
    { title: 'Morning', value: false, type: 'morning' },
    { title: 'Afternoon', value: false, type: 'afternoon' },
    { title: 'Evening', value: false, type: 'evening' },
  ];

  soloOrTeamOptions = [
    {
      type: 'soloDriver',
      title: 'Solo Driver',
      value: false,
    },
    {
      type: 'teamDriver',
      title: 'Team Driver',
      value: false,
    },
  ];

  companyOrOwnerOptions = [
    {
      type: 'companyDriver',
      title: 'Company',
      value: false,
    },
    {
      type: 'ownerOperator',
      title: 'Owner Operator',
      value: false,
    },
    {
      type: 'leasePurchase',
      title: 'Lease Purchase',
      value: false,
    },
  ];

  // *********** Preset Data Set ***********
  hasCDL;
  newEndorsements: any = [];

  CDLLicense;
  experience: string = '';
  companyOrOwner: string = '';
  soloOrTeam: string = '';
  mostCommonFreight: string = '';
  endorsements: any = [];
  accidents: string = '';
  violations: string = '';
  interestTeamDriver: string = '';
  militaryExperience: string = '';
  bestContactTime: string = '';

  // ******** application preset data set ********
  firstName;
  lastName;
  email;
  phone;
  dob;
  zip;

  // ******** validation set ********
  validEmail = false;
  validZip = false;
  validPhone = false;
  validAllOther = false;

  noEndorsementActive = true;

  constructor(
    public user: UserProvider,
    public tools: ToolsProvider,
    public plt: Platform,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    public crudApi: CrudApiProvider
  ) {
    this.log('Hello JobSearchFormComponent Component');
  }

  ngOnInit() {
    this.currentCompany = _.get(this.user.info, 'currentCompany');

    this.hasCDL = _.get(this.user.info.jobSearchInfo, 'cdlLicense');

    if (this.hasCDL === true) {
      this.CDLLicense = true;
    } else {
      this.CDLLicense = false;
    }

    if (this.submittingApplication) {
      this.getApplicationPresetData();
      this.getTruckingExpPresetData();
      this.job = this.navParams.get('job');
    } else {
      this.getTruckingExpPresetData();
    }

    if (_.size(this.endorsements)) {
      this.noEndorsementActive = false;
    }
  }

  getApplicationPresetData() {
    this.firstName =
      _.get(this.user.info.jobSearchInfo, 'firstName') ||
      _.get(this.user.info, 'firstName') ||
      '';

    this.lastName =
      _.get(this.user.info.jobSearchInfo, 'lastName') ||
      _.get(this.user.info, 'lastName') ||
      '';
    this.email =
      _.get(this.user.info.jobSearchInfo, 'email') ||
      _.get(this.user.info, 'email') ||
      '';
    this.phone = _.get(this.user.info.jobSearchInfo, 'phone') || '';
    this.zip = _.get(this.user.info.jobSearchInfo, 'zip') || '';
    this.dob = _.get(this.user.info.jobSearchInfo, 'dob') || '';
  }

  getTruckingExpPresetData() {
    this.hasFilledOut =
      _.get(this.user.info.jobSearchInfo, 'hasFilledOut') || false;
    this.hasCDL = _.get(this.user.info.jobSearchInfo, 'cdlLicense');

    if (this.hasCDL === undefined) {
      this.hasCDL = '';
    } else if (this.hasCDL) {
      this.hasCDL = 'yes';
    } else {
      this.hasCDL = 'no';
    }

    this.hasCDLOptions.filter(element => {
      if (this.hasCDL.includes(element.type)) {
        element.value = true;
      }
    });

    this.experience = _.get(this.user.info.jobSearchInfo, 'experience') || '';
    this.experienceOptions.filter(element => {
      if (this.experience.includes(element.type)) {
        element.value = true;
      }
    });

    this.soloOrTeam = _.get(this.user.info.jobSearchInfo, 'soloOrTeam') || '';
    this.soloOrTeamOptions.filter(element => {
      if (this.soloOrTeam.includes(element.type)) {
        element.value = true;
      }
    });

    this.companyOrOwner =
      _.get(this.user.info.jobSearchInfo, 'companyOrOwner').toLowerCase() || '';
    this.companyOrOwnerOptions.forEach(element => {
      if (this.companyOrOwner.includes(element.type.toLowerCase())) {
        element.value = true;
      }
    });

    this.mostCommonFreight =
      _.get(this.user.info.jobSearchInfo, 'mostCommonFreight') || '';
    this.FreightTypes.filter(element => {
      if (this.mostCommonFreight.includes(element.type)) {
        element.value = true;
      }
    });

    this.endorsements =
      _.get(this.user.info.jobSearchInfo, 'endorsements') || [];
    this.Endorsements.forEach(element => {
      if (this.endorsements.includes(element.type)) {
        element.value = true;
      }
    });

    this.accidents = _.get(this.user.info.jobSearchInfo, 'accidents') || '';
    this.Accidents.filter(element => {
      if (this.accidents.includes(element.type)) {
        element.value = true;
      }
    });
    this.violations = _.get(this.user.info.jobSearchInfo, 'violations') || '';
    this.Violations.filter(element => {
      if (this.violations.includes(element.type)) {
        element.value = true;
      }
    });

    this.interestTeamDriver =
      _.get(this.user.info.jobSearchInfo, 'interestTeamDriver') || '';
    this.TeamDrivers.filter(element => {
      if (this.interestTeamDriver.includes(element.type)) {
        element.value = true;
      }
    });

    this.militaryExperience =
      _.get(this.user.info.jobSearchInfo, 'militaryExperience') || '';
    this.Military.filter(element => {
      if (this.militaryExperience.includes(element.type)) {
        element.value = true;
      }
    });

    this.bestContactTime =
      _.get(this.user.info.jobSearchInfo, 'bestContactTime') || '';
    this.ContactTime.filter(element => {
      if (this.bestContactTime.includes(element.type)) {
        element.value = true;
      }
    });
  }

  selectCompanyOrOwner(opt) {
    this.companyOrOwner = opt.type;
    this.companyOrOwnerOptions.filter(element => {
      if (element.type === this.companyOrOwner) {
        element.value = !element.value;
      }
      if (element.type !== this.companyOrOwner) {
        element.value = false;
      }
    });
  }

  selectSoloOrTeam(opt) {
    this.soloOrTeam = opt.type;
    this.soloOrTeamOptions.filter(element => {
      if (element.type === this.soloOrTeam) {
        element.value = !element.value;
      }
      if (element.type !== this.soloOrTeam) {
        element.value = false;
      }
    });
  }

  clearEndorsements() {
    for (let endorsement of this.Endorsements) {
      endorsement.value = false;
    }
    this.endorsements = [];
    this.noEndorsementActive = true;
  }

  selectEndorsement(opt) {
    _.each(this.Endorsements, e => {
      if (e.type === opt.type) {
        _.set(e, 'value', !opt.value);
      }
    });

    this.endorsements = _.map(
      _.filter(this.Endorsements, e => {
        return e.value;
      }),
      'type'
    );
  }

  selectExperience(opt) {
    this.experience = opt.type;
    this.experienceOptions.filter(element => {
      if (element.type === this.experience) {
        element.value = !element.value;
      }
      if (element.type !== this.experience) {
        element.value = false;
      }
    });
  }

  selectFreightType(opt) {
    this.mostCommonFreight = opt.type;
    this.FreightTypes.filter(element => {
      if (element.type === this.mostCommonFreight) {
        element.value = !element.value;
      }
      if (element.type !== this.mostCommonFreight) {
        element.value = false;
      }
    });
  }

  markAsChanged() {
    if (!this.emittedChangesMade) {
      this.formChanged.emit();
      this.emittedChangesMade = true;
    }
  }

  fixScroll() {
    if (this.plt.is('ios')) {
      const scrolls = $('.scroll-content');
      scrolls.removeClass('scroll-content');
      setTimeout(() => {
        scrolls.addClass('scroll-content');
      }, 10);
    }
  }

  selectAccident(opt) {
    this.accidents = opt.type;
    this.Accidents.filter(element => {
      if (element.type === this.accidents) {
        element.value = !element.value;
      }
      if (element.type !== this.accidents) {
        element.value = false;
      }
    });
  }

  selectViolation(opt) {
    this.violations = opt.type;
    this.Violations.filter(element => {
      if (element.type === this.violations) {
        element.value = !element.value;
      }
      if (element.type !== this.violations) {
        element.value = false;
      }
    });
  }

  selectContactTime(opt) {
    this.bestContactTime = opt.type;
    this.ContactTime.filter(element => {
      if (element.type === this.bestContactTime) {
        element.value = !element.value;
      }
      if (element.type !== this.bestContactTime) {
        element.value = false;
      }
    });
  }

  selectMilitary(opt) {
    this.militaryExperience = opt.type;
    this.Military.filter(element => {
      if (element.type === this.militaryExperience) {
        element.value = !element.value;
      }
      if (element.type !== this.militaryExperience) {
        element.value = false;
      }
    });
  }

  selectTeamDriver(opt) {
    this.interestTeamDriver = opt.type;
    this.TeamDrivers.filter(element => {
      if (element.type === this.interestTeamDriver) {
        element.value = !element.value;
      }
      if (element.type !== this.interestTeamDriver) {
        element.value = false;
      }
    });
  }

  selectCDL(opt) {
    this.hasCDL = opt.type;

    this.hasCDLOptions.filter(element => {
      element.value = !element.value;
    });

    if (this.hasCDL === 'no') {
      this.CDLLicense = false;
    }
    if (this.hasCDL === 'yes') {
      this.CDLLicense = true;
    }
  }

  validateZipCode() {
    const zipCodePattern = /^\d{5}$|^\d{5}-\d{4}$/;
    if (zipCodePattern.test(this.zip)) {
      this.validZip = true;
    } else {
      this.validZip = false;
      this.tools.defaultAlert('Please provide a valid zip code.');
      return;
    }
  }

  validateEmail() {
    const emailPattern =
      /^([\w\-\.\+]+)@((\[([0-9]{1,3}\.){3}[0-9]{1,3}\])|(([\w\-]+\.)+)([a-zA-Z]{2,4}))$/;
    if (emailPattern.test(this.email)) {
      this.validEmail = true;
    } else {
      this.validEmail = false;
      this.tools.defaultAlert('Please provide a valid email.');
      return;
    }
  }

  validatePhone() {
    const phonePattern =
      /^\d{10}$|^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (phonePattern.test(this.phone)) {
      this.validPhone = true;
    } else {
      this.validPhone = false;
      this.tools.defaultAlert('Please provide a valid phone number.');
      return;
    }
  }

  validateAllOther() {
    if (
      this.CDLLicense ||
      this.firstName ||
      this.lastName ||
      this.dob ||
      this.experience !== '' ||
      this.companyOrOwner !== '' ||
      this.soloOrTeam !== '' ||
      this.mostCommonFreight !== '' ||
      this.accidents !== '' ||
      this.violations !== '' ||
      this.militaryExperience !== '' ||
      this.interestTeamDriver !== '' ||
      this.bestContactTime !== '' ||
      this.endorsements !== []
    ) {
      this.hasFilledOut = true;
      this.validAllOther = true;
    } else {
      this.validAllOther = false;
      this.tools.defaultAlert('Please Complete all application fields');
      return;
    }
  }

  getCurrentCompany() {
    return this.currentCompany;
  }

  clearCompany(event) {
    event.stopPropagation();
    this.currentCompany = null;
  }

  submit() {
    if (this.submittingApplication) {
      this.validateZipCode();
      this.validateEmail();
      this.validatePhone();
      this.validateAllOther();

      if (
        this.validEmail &&
        this.validZip &&
        this.validPhone &&
        this.validAllOther
      ) {
        this.hasFilledOut = true;
        return {
          zip: this.zip,
          dob: this.dob,
          email: this.email,
          phone: this.phone,
          firstName: this.firstName,
          lastName: this.lastName,
          hasFilledOut: this.hasFilledOut,
          cdlLicense: this.CDLLicense,
          endorsements: this.endorsements,
          experience: this.experience,
          accidents: this.accidents,
          violations: this.violations,
          companyOrOwner: this.companyOrOwner,
          soloOrTeam: this.soloOrTeam,
          mostCommonFreight: this.mostCommonFreight,
          interestTeamDriver: this.interestTeamDriver,
          militaryExperience: this.militaryExperience,
          bestContactTime: this.bestContactTime,
        };
      } else {
        this.hasFilledOut = false;
        return;
      }
    } else {
      this.hasFilledOut = true;
      return {
        hasFilledOut: this.hasFilledOut,
        cdlLicense: this.CDLLicense,
        endorsements: this.endorsements,
        experience: this.experience,
        accidents: this.accidents,
        violations: this.violations,
        companyOrOwner: this.companyOrOwner,
        soloOrTeam: this.soloOrTeam,
        mostCommonFreight: this.mostCommonFreight,
        interestTeamDriver: this.interestTeamDriver,
        militaryExperience: this.militaryExperience,
        bestContactTime: this.bestContactTime,
      };
    }
  }

  findCompany() {
    const modal = this.modalCtrl.create('CompanyListPage', {
      cssClass: 'SlideOver',
    });
    modal.onDidDismiss(data => {
      if (data) {
        this.currentCompany = data;
      }
    });
    this.tools.logAnalyticsEvent('trackCustom', 'open-company-list-profile');
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/job-search-form/job-search-form.ts